import menus from './menus';
import navDropdowns from './navDropdowns';
import navMenus from './navMenus';
import mobileMenu from './mobileMenu';
import headroomInit from './headroomInit';
import { announcementInit } from './announcements';
import themeEditor from './themeEditor';

const Header = () => {
  menus();
  navDropdowns();
  navMenus();
  mobileMenu();
  headroomInit();
  themeEditor();

  document.querySelectorAll('[data-announcements-carousel]').forEach((carousel) => {
    announcementInit(carousel);
  });

  // Reinit headroom when crossing over between 'desktop' and 'mobile' (really going from tablet to laptop or vice versa)
  let previousBreakpoint = window.theme.breakpoints.current;

  window.addEventListener('breakpointChange', (e) => {
    const breakpoint = e.detail.breakpoint;

    if (
      (breakpoint === 'mobile' || breakpoint === 'tablet') &&
      (previousBreakpoint === 'mobile' || previousBreakpoint === 'tablet')
    ) {
      return;
    }

    headroomInit();
    previousBreakpoint = breakpoint;
  });
};

export { Header };
